import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelMatriculasView from './PanelMatriculasView';
import * as ROUTES from '../../../../router/Routes';

const PanelMatriculasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelMatriculas}
      routes={[ROUTES.controlEstudios, ROUTES.matriculas]}
    >
      <PanelMatriculasView />
    </ContainerTemplate>
  );
};

export default PanelMatriculasModule;
